import styled, { css } from 'styled-components'
import { SearchableList } from '../SearchableList'

export const StyledSearchableList = styled(SearchableList)``

export const FilterContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xsmall};
  flex-wrap: wrap;
  padding: ${({ theme }) => theme.spacing.default};
  background: ${({ theme }) => theme.colors.background.primary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
`

export const FilterPill = styled.button<{ $active: boolean }>`
  padding: ${({ theme }) => theme.spacing.xsmall}
    ${({ theme }) => theme.spacing.small};
  background: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: nowrap;
  font-family: inherit;

  &:hover {
    background: ${({ theme }) => theme.colors.background.tertiary};
    border-color: ${({ theme }) => theme.colors.text.tertiary};
  }

  ${({ $active, theme }) =>
    $active &&
    css`
      background: ${theme.colors.primaryLight};
      border-color: ${theme.colors.primary};
      color: ${theme.colors.primary};
    `}
`

export const DateLabel = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.tertiary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: ${({ theme }) => theme.spacing.small};
  padding-left: ${({ theme }) => theme.spacing.default};
  margin-top: ${({ theme }) => theme.spacing.large};

  &:first-of-type {
    margin-top: ${({ theme }) => theme.spacing.default};
  }
`

export const EmptyState = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.huge}
    ${({ theme }) => theme.spacing.large};
`

export const EmptyIcon = styled.div`
  color: ${({ theme }) => theme.colors.text.tertiary};
  margin: 0 auto ${({ theme }) => theme.spacing.default};
  width: 48px;
  height: 48px;
`

export const EmptyTitle = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: ${({ theme }) => theme.spacing.xsmall};
`

export const EmptyDescription = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const LoadingContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ErrorContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.large};
`

export const ErrorContent = styled.div`
  text-align: center;

  p {
    color: ${({ theme }) => theme.colors.text.secondary};
    margin-bottom: ${({ theme }) => theme.spacing.default};
  }
`
